<script setup>
import { VueFinalModal } from 'vue-final-modal';
import VfmHeader from 'resources/js/components/VfmHeader.vue';

const emit = defineEmits(['close']);
</script>

<template>
    <VueFinalModal
        :esc-to-close="true"
        :click-to-close="true"
        class="prime-modal prime-tv-plus-mobile-modal"
    >
        <div class="prime-tv-plus-mobile-modal__cont">
            <VfmHeader
                title="TV+ mobile"
                class="prime-modal__header prime-tv-plus-mobile-modal__header"
                @close="emit('close')"
            />

            <div class="prime-tv-plus-mobile-modal__body">
                Бесплатный TV+ к каждой SIM-карте, без учёта мобильного трафика.<br><br>
                Смотрите 160+ телеканалов и 8 онлайн-кинотеатров!
            </div>
        </div>
    </VueFinalModal>
</template>

<style lang="scss">
@import 'resources/sass/variables';

.prime-tv-plus-mobile-modal {
    .vfm__content {
        max-width: 800px;
        background: #0F0E0E;
    }

    &__header {
        padding-left: 44px !important;
        background: #0F0E0E;

        .vfm__title {
            width: 100%;
            text-align: center;
            color: #DDAA4C;
        }
    }

    &__body {
        padding: 0 36px 36px;
        text-align: center;
        font-size: 18px;
        font-weight: $font-weight-semibold;
        color: white;

        @media screen and (max-width: $mobile-max-width) {
            padding: 0 24px 24px;
        }
    }
}
</style>
